import { faArrowRight, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { useState } from "react"
import { Link } from "react-router-dom"

import classNames from "classnames"
import api, { ApiFieldError } from "../../../services/api"
import Input from "../../components/input"
import useFlash from "../../hooks/use_flash"

export default function ForgotPasswordPage() {
  const { setFlash } = useFlash()

  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState("")
  const [showSuccess, setShowSuccess] = useState(false)
  const [inProgress, setInProgress] = useState(false)

  const formSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setInProgress(true)

    if (email.length === 0) {
      setEmailError("Please enter your email address.")
      setInProgress(false)
      return
    }

    api()
      .post("/api/accounts/reset-password", { email_address: email })
      .then((response) => {
        const { data } = response
        setEmailError("")
        setInProgress(false)

        if (data.status === "error") {
          data.errors.forEach((error: ApiFieldError) => {
            if (error.field == "email_address") {
              setEmailError(error.message)
            }
          })
        } else {
          setEmail("")
          setEmailError("")
          setShowSuccess(true)
        }
      })
      .catch((error) => {
        console.error(error)
        setFlash({
          type: "error",
          text: "Sorry, something went wrong. Please try again later, or contact support.",
        })
        setInProgress(false)
      })
  }

  return (
    <>
      <div className="flex min-h-full flex-col justify-start py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-200">
            Forgot password?
          </h2>
          <div className="mt-2 text-sm text-center">
            <Link to="/app/login" className="font-medium text-indigo-600 hover:text-indigo-500">
              Log in instead
              <FontAwesomeIcon icon={faArrowRight} className="ml-1 text-xs" />
            </Link>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white dark:bg-gray-900 px-4 py-8 shadow sm:rounded-lg sm:px-10">
            {!showSuccess && (
              <form className="space-y-6" onSubmit={formSubmit} method="POST">
                <Input
                  label="Email address"
                  name="email"
                  type="text"
                  error={emailError}
                  onChange={(newValue) => setEmail(newValue)}
                  disabled={inProgress}
                  value={email}
                />

                <div>
                  <button
                    type="submit"
                    data-testid="login-button"
                    className={classNames(
                      "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-500 dark:disabled:bg-gray-600"
                    )}
                    disabled={inProgress}
                  >
                    {inProgress && (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        className="dark:text-gray-100 text-gray-400 mt-1 mr-2"
                        spin
                      />
                    )}
                    Reset
                  </button>
                </div>
              </form>
            )}
            {showSuccess && (
              <div className="text-center" data-testid="success-message">
                Reset password email sent.
                <br />
                Please check your inbox.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
